<template>
    <b-card>
      <ChatbotThreadsTable/>
    </b-card>
</template>

<script>
import ChatbotThreadsTable from '@/components/Dashboard/Views/excmchatbot/ChatbotThreadsTable'

export default {
  name: 'ChatbotThreadsList',
  components: {
    ChatbotThreadsTable
  },
  created () {
  },
  methods: {
  }
}
</script>
